import React, { useEffect, useState } from "react";
import { getProducts, getProductsCount, getRelated } from "../../functions/product";
import ProductCard from "../cards/ProductCard";
import LoadingCard from "../cards/LoadingCard";
import Pagination from "../../components/Pagination";
import { Link, useHistory } from "react-router-dom";
import { getSub, getMiniSub } from "../../functions/sub";


const HoliSection = ({ pullCategory, name, history }) => {
  const [category, setCategory] = useState({});
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [productsCount, setProductsCount] = useState(0);
  const postPerPage = 5; // Moved as a constant since it doesn't change

  useEffect(() => {
    setLoading(true);
    getSub(pullCategory, page, postPerPage).then((res) => {
      if (res.data.sub === null) {
        history.push('/');
      } else {
        setCategory(res.data.sub);
        setProducts(res.data.products);
        setProductsCount(res.data.totalCount); // Assuming your backend is adjusted to send totalCount
        setLoading(false);

        console.log(res.data.products);
      }
    });
  }, [pullCategory, page]);


  return (
    <>
      {products.length > 0 && (
        <>
          <div key={category._id} className="pdl-generic-content_full">
            <div className="product-view product-view-search">
              <div className="product-set spyglass-nav-group_wrapper">
                <div>
                  <div className="zone-block zone-block-xlarge" has-shopping-list-menu="true">
                    <div className="zone-block_content">
                      <div className="zone-block_header">
                        <h2 className="zone-block_title"> {name} </h2>
                        <Link to={`/sub/${pullCategory}`}>
                          <button aria-label="View all products" className="zone-block_link zone-block_link--zone-carousel">
                            View All
                            <div className="zone-block_link-icon"><svg xmlns="http://www.w3.org/2000/svg" aria-label="Next arrow" viewBox="0 0 32 32" role="presentation" aria-hidden="true" focusable="false" className>
                              <title lang="en">Next arrow</title>
                              <desc />
                              <g fill stroke="inherit">
                                <path d="M0.626 31.374c0.833 0.833 2.188 0.833 3.021 0l13.858-13.858c0.419-0.419 0.628-0.97 0.624-1.517 0-0.551-0.205-1.098-0.624-1.517l-13.858-13.856c-0.833-0.833-2.188-0.833-3.021 0s-0.833 2.188 0 3.021l12.354 12.354-12.354 12.354c-0.833 0.833-0.833 2.188 0 3.019z">
                                </path>
                              </g>
                            </svg></div></button>
                        </Link>
                      </div>
                      <div className="pdl-carousel pdl-carousel--xlarge" style={{ touchAction: 'pan-y', userSelect: 'none', WebkitUserDrag: 'none', WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)' }}>
                        <div className="pdl-carousel_row">
                          <div className="pdl-carousel_body"><button aria-label="Previous slide" className="button--reset pdl-carousel_trigger pdl-carousel_trigger--prev" style={{ display: 'none' }}>
                            <div className="pdl-carousel_trigger-icon"><svg xmlns="http://www.w3.org/2000/svg" aria-label="Previous" viewBox="0 0 32 32" role="presentation" aria-hidden="true" focusable="false" className>
                              <title lang="en">Previous</title>
                              <desc />
                              <g fill stroke="black">
                                <polyline fill="none" strokeWidth={2} strokeLinecap="square" transform="translate(15.242750, 16.485250) rotate(-180.000000) translate(-15.242750, -16.485250)" points="11 8 19.4855 16.485 11 24.9705" />
                              </g>
                            </svg></div>
                          </button>
                         
                          <div className="pdl-carousel_container" style={{ minHeight: 'auto' }}>
                              <div className="" style={{ transform: 'translateX(0px)', height: 'auto', position: 'relative' }}>
                                <div tabIndex={-1} className="pdl-carousel_item zone-block_carousel-item" style={{ height: 'auto', width: '1240px' }}>
                                  <ul className="product-list product-list-quint" view-size="xlarge" itemcountpriorslide="[object Object]" index={0}>
                                    {loading ? (
                                      <LoadingCard count={postPerPage} />
                                    ) : (
                                      products.map((product) => (
                                        <ProductCard key={product._id} product={product} />
                                      ))
                                    )}
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="rewards-zone-dashboard pdl-generic-content_container--max">
            <Pagination postPerPage={postPerPage} totalPosts={productsCount} paginate={setPage} currentPage={page} />
          </div>
        </>
      )}

    </>
  )
}

export default HoliSection;